import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import './signin.css';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;
  
      try {
        // Check if the user is an admin
        const adminDoc = await getDoc(doc(db, 'admins', userId));
        console.log('Admin Document:', adminDoc.data());
        if (adminDoc.exists() && adminDoc.data().role === 'admin') {
          navigate('/adminpanel'); // Redirect to admin panel
        } else {
          navigate('/'); // Redirect to the main page for regular users
        }
      } catch (firestoreError) {
        console.error('Firestore Error:', firestoreError);
        setError('Error verifying admin status');
      }
    } catch (authError) {
      console.error('Login Error:', authError);
      setError(authError.message || 'Invalid email or password');
    }
  };


  
  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  
  return (
    <div className="form-container">
      <h2>Sign In</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        
        <button type="submit" className="form-btn">Login</button>

             <a 
                href="/ForgotPassword" 
                className="forgot-password-link"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default action if using JavaScript handling
                  navigateToForgotPassword(); // Optional: Function to navigate programmatically
                }}
              >
                Forgot Password?
              </a>

      </form>
    </div>
  )
}

export default SignIn